// Centralised test IDs for the My Crest Club Special Orders app.
//
// NOTE: any string in this file that contains "password" / "passcode" /
// "secret" is a STABLE TEST SELECTOR for an input element — used by
// Playwright/RTL via `data-testid`. They are NOT secrets, credentials,
// or API keys. The actual secrets live in `.env` files and never touch
// the frontend bundle. Static-analysis tools that flag this file for
// "hardcoded secrets" are false positives.
export const AUTH = {
  loginEmail: "login-email-input",
  loginPassword: "login-password-input",
  loginSubmit: "login-submit-button",
  loginGoogle: "login-google-button",
  loginRegisterLink: "login-register-link",
  loginForgotLink: "login-forgot-link",
  forgotEmail: "forgot-email-input",
  forgotSubmit: "forgot-submit-button",
  resetPassword: "reset-password-input",
  resetConfirm: "reset-password-confirm-input",
  resetSubmit: "reset-submit-button",
  registerName: "register-name-input",
  registerEmail: "register-email-input",
  registerMembership: "register-membership-input",
  registerPhone: "register-phone-input",
  registerPassword: "register-password-input",
  registerSubmit: "register-submit-button",
  registerLoginLink: "register-login-link",
  logoutButton: "logout-button",
  errorBanner: "auth-error-banner",
  successBanner: "auth-success-banner",
};

export const NAV = {
  brand: "nav-brand",
  memberHome: "nav-member-home",
  memberNew: "nav-member-new-order",
  memberHistory: "nav-member-history",
  adminOrders: "nav-admin-orders",
  adminMembers: "nav-admin-members",
  profile: "nav-profile",
};

export const ORDER = {
  newItemName: "order-item-name-input",
  newCategory: "order-category-select",
  newColor: "order-color-input",
  newSize: "order-size-input",
  newQuantity: "order-quantity-input",
  newLogo: "order-logo-input",
  newVendor: "order-vendor-input",
  newNotes: "order-notes-textarea",
  newPhotoInput: "order-photo-input",
  newPhotoDropzone: "order-photo-dropzone",
  newSubmit: "order-submit-button",
  detailStatus: "order-detail-status",
  detailStatusSelect: "order-detail-status-select",
  detailStatusUpdate: "order-detail-status-update-button",
  detailNotifyMember: "order-detail-notify-member-checkbox",
  detailInternalNote: "order-detail-internal-note-textarea",
  detailInternalNoteAdd: "order-detail-internal-note-add-button",
  detailMessage: "order-detail-message-textarea",
  detailMessageSend: "order-detail-message-send-button",
  emailToggle: "order-email-toggle",
  emailSubject: "order-email-subject-input",
  emailBody: "order-email-body-textarea",
  emailSend: "order-email-send-button",
  emailLogTab: "order-email-log-tab",
  emailLogList: "order-email-log-list",
  vendorConfirmed: "order-vendor-confirmed-input",
  vendorPo: "order-vendor-po-input",
  vendorTracking: "order-vendor-tracking-input",
  vendorCarrier: "order-vendor-carrier-input",
  vendorEta: "order-vendor-eta-input",
  vendorSave: "order-vendor-save-button",
  rowPrefix: "order-row-",
  cardPrefix: "order-card-",
};

export const ADMIN = {
  statsTotal: "admin-stats-total",
  statsMembers: "admin-stats-members",
  filterStatus: "admin-filter-status",
  navIntelligence: "nav-admin-intelligence",
  intelligencePage: "admin-intelligence-page",
  intelTotalOrders: "intel-total-orders",
  intelTotalMembers: "intel-total-members",
  intelOnboarded: "intel-onboarded-members",
  intelGrowth: "intel-growth-pct",
  intelExportOrders: "intel-export-orders",
  intelExportMembers: "intel-export-members",
  intelExportIntel: "intel-export-intel",
};

export const MASTER = {
  pill: "master-passcode-pill",
};

export const TEMP_PASSCODE = {
  pill: "temp-passcode-pill",
  rotateCta: "temp-passcode-rotate-cta",
};

export const FORGOT_PASSCODE = {
  trigger: "forgot-passcode-trigger",
  panel: "forgot-passcode-panel",
  submit: "forgot-passcode-submit",
  cancel: "forgot-passcode-cancel",
  feedback: "forgot-passcode-feedback",
};

export const FORGOT_MASTER_PASSCODE = {
  trigger: "forgot-master-passcode-trigger",
  panel: "forgot-master-passcode-panel",
  submit: "forgot-master-passcode-submit",
  cancel: "forgot-master-passcode-cancel",
  feedback: "forgot-master-passcode-feedback",
};

export const TRASH = {
  // Tab toggles
  tabActive: "trash-tab-active",
  tabDeleted: "trash-tab-deleted",
  // Per-row buttons
  deletePrefix: "order-delete-",
  restorePrefix: "order-restore-",
  // Confirmation dialog
  confirm: "trash-confirm",
  confirmYes: "trash-confirm-yes",
  confirmCancel: "trash-confirm-cancel",
  // Countdown label
  countdownPrefix: "order-deletes-in-",
};

export const ORDER_FORM = {
  whereSeenSelect: "order-where-seen-select",
  whereSeenOtherInput: "order-where-seen-other-input",
};

export const WISHLIST = {
  navLink: "nav-wishlist",
  page: "wishlist-page",
  addCta: "wishlist-add",
  card: "wishlist-card-",
  edit: "wishlist-edit-",
  delete: "wishlist-delete-",
  convert: "wishlist-convert-",
  // Editor
  editor: "wishlist-editor",
  itemNameInput: "wishlist-item-name",
  collectionInput: "wishlist-collection",
  brandInput: "wishlist-brand",
  categoryInput: "wishlist-category",
  colorInput: "wishlist-color",
  sizeInput: "wishlist-size",
  notesInput: "wishlist-notes",
  whereSeenSelect: "wishlist-where-seen",
  whereSeenOtherInput: "wishlist-where-seen-other",
  shareToggle: "wishlist-share",
  save: "wishlist-save",
  cancel: "wishlist-cancel",
};

export const SUPER_ADMIN = {
  loginEmail: "sa-login-email",
  loginPassword: "sa-login-password",
  loginSubmit: "sa-login-submit",
  forgotTrigger: "sa-forgot-trigger",
  forgotSubmit: "sa-forgot-submit",
  forgotFeedback: "sa-forgot-feedback",
  resetSubmit: "sa-reset-submit",
  resetFeedback: "sa-reset-feedback",
  dashboard: "super-admin-dashboard",
  kpiMembers: "sa-kpi-members",
  kpiActiveOrders: "sa-kpi-active-orders",
  kpiTrashed: "sa-kpi-trashed",
  kpiWishlist: "sa-kpi-wishlist",
  kpiAuditCount: "sa-kpi-audit",
  auditTable: "sa-audit-table",
  auditFilter: "sa-audit-filter",
};

export const HOME = {
  emergentLink: "home-emergent-link",
};

export const CREST = {
  // Banner on member dashboard
  banner: "crest-onboarding-banner",
  bannerStart: "crest-onboarding-start",
  bannerDismiss: "crest-onboarding-dismiss",
  // Wizard
  wizard: "crest-wizard",
  wizardStep: "crest-wizard-step",
  wizardNext: "crest-wizard-next",
  wizardBack: "crest-wizard-back",
  wizardSkip: "crest-wizard-skip",
  wizardSave: "crest-wizard-save",
  wizardClose: "crest-wizard-close",
  // Inputs
  mobileInput: "crest-mobile-input",
  sizingPrefix: "crest-sizing-",  // + shirt/hat/outerwear/shoe/belt
  stylePrefix: "crest-style-",  // + lowercased label
  categoryPrefix: "crest-category-",  // + lowercased label
  brandPrefix: "crest-brand-",  // + lowercased label
  logoPrefix: "crest-logo-",  // + lowercased label
  logoComingSoonPrefix: "crest-logo-coming-soon-",  // + lowercased label, for disabled chips
  brandOtherInput: "crest-brand-other-input",
  brandOtherAdd: "crest-brand-other-add",
  // Crest profile page
  page: "crest-profile-page",
  navLink: "nav-crest-profile",
  editMobile: "crest-edit-mobile",
  editSizing: "crest-edit-sizing",
  editStyles: "crest-edit-styles",
  editBrands: "crest-edit-brands",
  editCategories: "crest-edit-categories",
  editLogos: "crest-edit-logos",
  saveFeedback: "crest-save-feedback",
};
